import { useAuth0 } from "@auth0/auth0-react";
import { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { fetchCalendarEvents } from "redux/actions/flowDesigner/calendarActionCreator";
import useSharedSchedules from "hooks/useSharedSchedules";
import { useUserRole } from "./useUserRole";
import { permissionChecker } from "helpers/common";
import { PermissionsContext } from "context/AppProvider/PermissionsContext";
import { PERMISSIONS } from "constants/portal";

export const useSchedules = () => {
  const { user } = useAuth0();
  const dispatch = useDispatch();
  const { sharedSchedules, reloadSharedSchedules } = useSharedSchedules();
  const { calendarEvents } = useSelector((store) => store?.designer?.calendar);
  const [ownedSchedules, setOwnedSchedules] = useState([]);
  const [ownedSharedSchedules, setOwnedSharedSchedules] = useState([]);
  const { isOwnerRole } = useUserRole();
  const { userPermissions } = useContext(PermissionsContext);

  const handleFetchCalendarEvents = () => {
    if (!user?.stripeId) return;

    dispatch(fetchCalendarEvents(user?.stripeId));
  };

  const reloadSchedules = () => {
    handleFetchCalendarEvents();
  };

  const determineShareStatus = (schedule) => {
    if (schedule.created_by_id === user.cxfUserId) {
      return "Owner";
    } else if (
      sharedSchedules
        ?.filter((s) => s.schedule_id === schedule.id)
        .some((s) => s.shared_user_id === user.cxfUserId)
    ) {
      return "Shared";
    } else {
      return "";
    }
  };

  useEffect(() => {
    if (calendarEvents?.length) return;

    handleFetchCalendarEvents();
  }, []);

  useEffect(() => {
    if (calendarEvents?.length) {
      const filteredSchedules = calendarEvents.filter((event) => {
        if (isOwnerRole || permissionChecker(userPermissions, PERMISSIONS.VIEW_ANY_SCHEDULES)) {
          return true;
        }

        const foundSharedSchedule = sharedSchedules.find(
          (schedule) =>
            schedule.schedule_id === event.id && user.cxfUserId === schedule.shared_user_id
        );

        if (foundSharedSchedule || event.created_by_id === user?.cxfUserId) return true;

        return false;
      });
      setOwnedSchedules(calendarEvents.filter((event) => event.created_by_id === user?.cxfUserId));

      setOwnedSharedSchedules(filteredSchedules);
    } else {
      setOwnedSchedules([]);
      setOwnedSharedSchedules([]);
    }
  }, [calendarEvents, sharedSchedules, isOwnerRole, userPermissions]);

  return {
    calendarEvents,
    reloadSchedules,
    ownedSchedules,
    sharedSchedules,
    reloadSharedSchedules,
    ownedSharedSchedules,
    determineShareStatus
  };
};
